import React, { useState, useEffect } from "react";
import { Button, TextField } from "@mui/material";
import ButtonStyle from "components/Button/ButtonStyle.module.css";
import { apiGet } from "app/Services/ApiService";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { Utils } from "common/Utils";

import moment from "moment";
import AximDropdown from "./Dropdown/AximDropdown";

export default function TimeFrameDateSelector({ payPeriodsUrl, handleView, isViewEnabled, doUseName, defaultValue }) {
    const [timeframe, setTimeframe] = useState("Monthly");
    const [selectedStartDate, setSelectedStartDate] = useState("");
    const [startDatesDropdown, setStartDatesDropdown] = useState([]);

    const [selectedYear, setSelectedYear] = useState("");
    const [yearDropdown, setYearDropdown] = useState([]);

    const [selectedQuarter, setSelectedQuarter] = useState("");
    const [quarterDropdown, setQuarterDropdown] = useState([]);

    const [selectedYearOnly, setSelectedYearOnly] = useState("");
    
    const [name, setName] = useState("");

    const [isLoadingData, setIsLoadingData] = useState(false);
    const [doView, setDoView] = useState(false);

    useEffect(() => {
        setIsLoadingData(true);

        apiGet(payPeriodsUrl).then((response) => {
            setTimeframe("Monthly");
            var found = null;

            var dates = response.data.map(d => new Date(d));
            setStartDatesDropdown(dates);
            if (dates.length > 0) {
                found = dates.find(e => Utils.formatDate(e) === Utils.formatDate(defaultValue));
    
                if (found) {
                    setSelectedStartDate(found);
                }
                else {
                    setSelectedStartDate(dates[0]);
                }
            }

            var years = dates.map(d => d.getYear() + 1900).filter(onlyUnique);
            setYearDropdown(years);
            if (years.length > 0) {
                setSelectedYear(years[0]);
                setSelectedYearOnly(years[0]);
            }

            setIsLoadingData(false);

            if (found) {
                setDoView(true);
            }
        });
    },[payPeriodsUrl,defaultValue]);

    useEffect(() => {
        var quarters = startDatesDropdown.filter(d => d.getYear() + 1900 === selectedYear)
            .map(d => Math.floor(d.getMonth() / 3) + 1)
            .filter(onlyUnique)
            .map(d => `${d}${nth(d)}`);

        setQuarterDropdown(quarters)
        if (quarters.length > 0) {
            setSelectedQuarter(quarters[0]);
        }
    },[selectedYear]);

    useEffect(() => {
        if (doView) {
            view();

            setDoView(false);
        }
    },[doView])

    const onlyUnique = (value, index, self) => {
        return self.indexOf(value) === index;
    }

    const nth = (n) => {return["st","nd","rd"][((n+90)%100-10)%10-1]||"th"}

    const view = () => {
        let startDate = '';
        let endDate = '';
        
        if (timeframe === 'Monthly') {
            startDate = moment(selectedStartDate).format('yyyy-MM-DD');
        }
        else if (timeframe === 'Yearly') {
            startDate = moment(new Date(selectedYearOnly, 0, 1)).format('yyyy-MM-DD');
            endDate = moment(new Date(selectedYearOnly, 11, 31)).format('yyyy-MM-DD');
        }
        else if (timeframe === 'Quarterly') {
            if (selectedQuarter === '1st') {
                startDate = moment(new Date(selectedYear, 0, 1)).format('yyyy-MM-DD');
                endDate = moment(new Date(selectedYear, 2, 31)).format('yyyy-MM-DD');
            }
            else if (selectedQuarter === '2nd') {
                startDate = moment(new Date(selectedYear, 3, 1)).format('yyyy-MM-DD');
                endDate = moment(new Date(selectedYear, 5, 30)).format('yyyy-MM-DD');
            }
            else if (selectedQuarter === '3rd') {
                startDate = moment(new Date(selectedYear, 6, 1)).format('yyyy-MM-DD');
                endDate = moment(new Date(selectedYear, 8, 30)).format('yyyy-MM-DD');
            }
            else if (selectedQuarter === '4th') {
                startDate = moment(new Date(selectedYear, 9, 1)).format('yyyy-MM-DD');
                endDate = moment(new Date(selectedYear, 11, 31)).format('yyyy-MM-DD');
            }
        }

        handleView(timeframe, startDate, endDate, name);
    }

    return (
        <>
            <AximDropdown
                id="select-time-span"
                label="Time Span"
                handleChange={e => setTimeframe(e.target.value)}
                value={timeframe}
                pairs={[{value: "Monthly"}, {value: "Quarterly"}, {value: "Yearly"}]}
                disabled={isLoadingData || !isViewEnabled}
            />

            {timeframe === "Monthly" ? (
                <AximDropdown
                    id="pay-dates"
                    label="Pay Dates"
                    handleChange={e => setSelectedStartDate(e.target.value)}
                    value={selectedStartDate}
                    pairs={startDatesDropdown.sort((a,b) => b-a).map(d => ({ value: d, text: moment(d).format("MMMM DD, YYYY")}))}
                    disabled={isLoadingData || !isViewEnabled}
                />
            ) : timeframe === "Quarterly" ? (
                <>
                    <AximDropdown
                        id="quarter-year"
                        label="Year"
                        handleChange={e => setSelectedYear(e.target.value)}
                        value={selectedYear}
                        pairs={yearDropdown.map(y => ({ value: y }))}
                        disabled={isLoadingData || !isViewEnabled}
                    />
                    <AximDropdown
                        id="quarter"
                        label="Quarter"
                        value={selectedQuarter}
                        handleChange={e => setSelectedQuarter(e.target.value)}
                        pairs={quarterDropdown.map(q => ({ value: q }))}
                        disabled={isLoadingData || !isViewEnabled}
                    />
                </>
            ) : timeframe === "Yearly" ? (
                <AximDropdown
                    id="only-year"
                    label="Year"
                    value={selectedYearOnly}
                    handleChange={e => setSelectedYearOnly(e.target.value)}
                    pairs={yearDropdown.map(y => ({ value: y }))}
                    disabled={isLoadingData || !isViewEnabled}
                />
            ) : null}

            {doUseName ?
                <TextField
                    id="individual-view"
                    label="Last Name View"
                    type="search"
                    variant="standard"
                    focused
                    sx={{ marginRight: 1 }}
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    disabled={isLoadingData || !isViewEnabled} 
                /> : null}

            <Button
                variant="outlined"
                onClick={view}
                className={ButtonStyle.CsubmitBtn}
                sx={{ marginRight: 2 }}
                disabled={isLoadingData || !isViewEnabled}
                startIcon={<VisibilityOutlinedIcon />}
            >
                View
            </Button>
        </>
    );
}